import React from 'react';
import { Poppins, Spacer } from 'src/common';
import styled from 'styled-components';
import { VersionLockSvg } from 'src/assets/dynamicSvg';
import { formatDate } from 'src/utils/misc';
import { VersionObject } from '../useVersion';

const VersionContainer = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.cflowerBlue};
  }
`;

interface VersionHeaderProps {
  version: VersionObject;
}

export const VersionHeader: React.FC<VersionHeaderProps> = ({ version }) => {
  return (
    <VersionContainer data-cy="version-header">
      <VersionLockSvg />
      <Poppins px={14} color="cflowerBlue">
        {version.name}
      </Poppins>
      <Spacer $px={10} $horizontal />
      <Poppins px={14} color="cflowerBlue">
        |
      </Poppins>
      <Spacer $px={10} $horizontal />
      <Poppins px={14} color="cflowerBlue">
        {version.meta?.createdBy}
      </Poppins>
      <Spacer $px={10} $horizontal />
      <Poppins px={14} color="cflowerBlue">
        |
      </Poppins>
      <Spacer $px={10} $horizontal />
      <Poppins px={14} color="cflowerBlue">
        {formatDate(version.meta?.createdAt || '')}
      </Poppins>
    </VersionContainer>
  );
};
